module.exports = __webpack_public_path__ + "img/arrow-w.9d08d34e.svg";